import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Eye, EyeOff, KeyRound } from 'lucide-react';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const AlterarSenhaUsuario = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const nome = location.state?.nome || '';
  const [senha, setSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [mostrar, setMostrar] = useState(false);
  const [trocarNoProximoLogin, setTrocarNoProximoLogin] = useState(true);
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const administrador = user?.tipo === 'administrador' || user?.usuario_tipo === 'administrador';

  if (!administrador) {
    return (
      <div className="p-6">
        <p className="text-red-600">Somente o administrador pode alterar a senha de outro usuário.</p>
      </div>
    );
  }

  const salvar = async (e) => {
    e.preventDefault();
    setErro('');
    if (senha && senha.length < 6) {
      setErro('A senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (senha !== confirmacao) {
      setErro('As senhas não correspondem.');
      return;
    }
    if (!senha && !trocarNoProximoLogin) {
      setErro('Informe a nova senha ou marque a troca no próximo login.');
      return;
    }
    setSalvando(true);
    try {
      await api.put(`/usuarios/${id}/senha`, {
        senha,
        trocar_no_proximo_login: trocarNoProximoLogin
      });
      navigate('/usuarios');
    } catch (error) {
      setErro(error.response?.data?.message || 'Erro ao alterar a senha.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center gap-2 mb-2">
          <KeyRound className="h-5 w-5 text-indigo-600" />
          <h1 className="text-xl font-semibold text-gray-900">Alterar senha do usuário</h1>
        </div>
        <p className="text-sm text-gray-600 mb-6">{nome || `Usuário ${id}`}</p>

        <form onSubmit={salvar} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nova senha</label>
            <div className="relative">
              <input
                type={mostrar ? 'text' : 'password'}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 pr-10"
                autoComplete="new-password"
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 px-3 text-gray-500"
                onClick={() => setMostrar((v) => !v)}
              >
                {mostrar ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar senha</label>
            <input
              type={mostrar ? 'text' : 'password'}
              value={confirmacao}
              onChange={(e) => setConfirmacao(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              autoComplete="new-password"
            />
          </div>
          <label className="flex items-center gap-2 text-sm text-gray-800">
            <input
              type="checkbox"
              checked={trocarNoProximoLogin}
              onChange={(e) => setTrocarNoProximoLogin(e.target.checked)}
            />
            Alterar a senha no próximo login
          </label>
          {erro && <p className="text-sm text-red-600">{erro}</p>}
          <div className="flex gap-2">
            <button
              type="submit"
              disabled={salvando}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md disabled:opacity-60"
            >
              {salvando ? 'Salvando...' : 'Salvar'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/usuarios')}
              className="px-4 py-2 border border-gray-300 rounded-md"
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AlterarSenhaUsuario;
